import React, { useRef, useState, useContext, createContext, useEffect } from 'react';


export const ProgressContext = createContext<{
    progressTracker: number;
  setProgressTracker: React.Dispatch<React.SetStateAction<number>>;
}>({
  progressTracker: 0,
  setProgressTracker: () => {}
});

// Rest of the implementation remains the same
export const ProgressProvider=({ children })=> {
  const [progressTracker, setProgressTracker] = useState(0);
  
  return (
    <ProgressContext.Provider value={{ progressTracker, setProgressTracker }}>
      {children}
    </ProgressContext.Provider>
  );
}